import React, { useState, useEffect, useRef, useImperativeHandle } from "react";

import failed from "asset/music/failed.mp3";
import cry from "asset/img/cry.png";
import time from "asset/img/time.png";

import { useLocation, useNavigate } from "react-router-dom";
import WkModal from "components/Modal";
import { studyTimeSubmit } from "network";

import { calcSerial, formatTime } from "utils";

const Timer = React.forwardRef((props, ref) => {
  const {
    timeoutcb,
    levelIndex,
    name,
    pause,
    isAssessmentMode,
    serialId,
    menuUrl, // 父组件传入，影视入口无 type/index 时用此回 Menu
  } = props;
  let navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const index = searchParams.get("index");

  const audioFailedRef = useRef(null);
  // 倒计时：3 分钟
  const TIMER_SECONDS = 180;
  const [timeLeft, setTimeLeft] = useState(TIMER_SECONDS);
  const [timeSubmitStatus, setTimeSubmitStatus] = useState(true); // 组建内部控制是否提交学习记录

  const [timeOutVisible, setTimeOutVisible] = useState(false);

  const timerRef = useRef(null);
  const timeLeftRef = useRef(TIMER_SECONDS);
  timeLeftRef.current = timeLeft;

  useImperativeHandle(ref, () => ({
    reload: () => {
      setTimeLeft(TIMER_SECONDS);
    },
    getTimeLeft: () => timeLeftRef.current,
  }));

  // 关卡倒计时
  useEffect(() => {
    let timeoutId; // 改用 Timeout ID
    if (timeLeft > 0 && !pause) {
      timeoutId = setTimeout(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }
    if (timeLeft == 0) {
      // 播放失败音效
      audioFailedRef.current.play();
      // 打开弹窗
      setTimeOutVisible(true);
      // 停止提交学习记录
      setTimeSubmitStatus(false);
    }
    return () => clearTimeout(timeoutId); // 正确清理
  }, [timeLeft, pause]);

  useEffect(() => {
    if (!pause) {
      setTimeSubmitStatus(true);
    } else {
      setTimeSubmitStatus(false);
    }
  }, [pause]);

  const timeOutOk = () => {
    setTimeOutVisible(false);
    setTimeSubmitStatus(false);
    setTimeLeft(TIMER_SECONDS);
    if (timeoutcb) {
      timeoutcb();
    }
  };

  const successCancel = () => {
    if (isAssessmentMode) {
      navigate('/welcome');
      return;
    }
    if (menuUrl) {
      navigate(menuUrl);
      return;
    }
    navigate(`/menu?type=${type}&index=${index}`);
  };

  // 记录学习时间，当timeSubmitStatus变化时，停止计时；
  useEffect(() => {
    const startTimer = () => {
      // 确保先清理可能存在的定时器
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }

      // 创建新的定时器
      const sid = serialId != null && serialId !== undefined ? serialId : (isAssessmentMode ? serialId : calcSerial(type, index));
      if (sid == null || sid === undefined) return;
      timerRef.current = setInterval(() => {
        studyTimeSubmit({
          serial_id: sid,
          number: levelIndex,
        }).catch((err) => {
          console.log("学习时间提交失败", err);
          // 可以在这里添加重试逻辑或其他错误处理
        });
      }, 40000);
    };

    const stopTimer = () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };

    if (timeSubmitStatus) {
      startTimer();
    } else {
      stopTimer();
    }

    // 清理函数
    return () => {
      stopTimer();
    };
  }, [timeSubmitStatus, type, index, levelIndex, isAssessmentMode, serialId]);

  useEffect(() => {
    // 组件卸载时清理所有资源
    return () => {
      // 清理所有音频资源
      const audioElements = [audioFailedRef.current];

      audioElements.forEach((audio) => {
        if (audio) {
          audio.pause();
          audio.src = "";
          audio.load();
        }
      });
    };
  }, []);

  const timeoutContent = (
    <div className="detail-success">
      <div className="icon">
        <img src={cry} />
      </div>
      <div>很遗憾时间超出，闯关失败</div>
      <div>
        继续加油哦！<span className="number">{name}</span> 小朋友
      </div>
    </div>
  );

  //console.log("----timer组件更新");
  return (
    <div className="detail-content-control-time">
      <img src={time} />
      <div className="time">{formatTime(timeLeft)}</div>
      <audio
        ref={audioFailedRef}
        src={failed}
        controls
        className="detail-audio"
      />
      <WkModal
        visible={timeOutVisible}
        onOk={timeOutOk}
        content={timeoutContent}
        okText={"重新闯关"}
        onCancel={successCancel}
      />
    </div>
  );
});

export default Timer;
